import type { FC, ReactNode } from "react";
import { cn } from "../../lib/utils";

type DismissibleAlertProps = {
  children: ReactNode;
  variant?: "error" | "warning" | "info" | "success";
  className?: string;
  onDismiss: () => void;
};

const variantClass: Record<string, string> = {
  error: "alert-error",
  warning: "alert-warning",
  info: "alert-info",
  success: "alert-success",
};

/**
 * バツボタン付き閉じられるアラート
 * @param {DismissibleAlertProps} props コンポーネントProps
 * @return {JSX.Element} DismissibleAlert
 */
export const DismissibleAlert: FC<DismissibleAlertProps> = ({
  children,
  variant = "error",
  className,
  onDismiss,
}) => {
  return (
    <div
      className={cn(
        "alert flex justify-between items-center",
        variantClass[variant],
        className,
      )}
    >
      <span>{children}</span>
      <button
        type="button"
        className="btn btn-ghost btn-xs ml-auto"
        onClick={onDismiss}
      >
        ✕
      </button>
    </div>
  );
};
